import React, { useEffect, useState } from 'react';
import Invoice from 'src/models/leasing/Invoice';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import useFetch from 'use-http';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import { DialogWizardPage } from 'src/components/common/DialogWizard.redesign';
import DialogWizard from 'src/components/common/DialogWizard.redesign';
import RecordingFeeListDialog from './RecordingFeeListDialog';
import { FormRow } from 'src/components/controls/forms/reactHookForm';

interface IAddInvoiceDialogStateProps {
    invoice: Invoice;
    invoiceableLookupId: number;
    nextInvoiceNumber: string;
    clientNumber: number;
    projectNumber: number;
    dialogName: string;
    totalBonus: number;
    bonusType: string;
    bonusAmount: number;
    countyId: number;
    stateId: number;
    hideDialog: (reset: boolean) => void;
    formatData: (data: Invoice) => Invoice;
}

const AddInvoiceDialog = (props: IAddInvoiceDialogStateProps) => {
    const defaultValues: Invoice = {
        id: 0,
        invoiceNumber: props.nextInvoiceNumber,
        collectNumber: 0,
        collectionType: '',
        checkNumber: 0,
        invoiceDueDate: null,
        bonusAmount: props.totalBonus,
        draftDueDate: null,
        recordingFee: 0,
        rentAmount: 0,
        bankCharge: 0,
        invoiceTotal: props.totalBonus,
        checkDate: null,
        arDate: null,
        paidAmount: 0,
        datePaid: null,
        invoiceStatusId: 0,
        clientInvoiceNotes: '',
        otherFee: 0,
    };

    const [invoiceData, setInvoiceData] = useState(defaultValues);
    const [currentStep, setCurrentStep] = useState(0);
    const [invoiceForm, setInvoiceForm] = useState<Invoice>(undefined);
    const [submittingFees, setSubmittingFees] = useState<boolean>(false);

    const { put, post, response } = useFetch();
    const { register, getValues, setValue, handleSubmit, reset, errors } = useForm();

    const loadInvoiceData = async () => {
        if (props.invoice?.id && props.invoice.id > 0) {
            let formInvoice = props.formatData(props.invoice);
            setInvoiceData(formInvoice);
        } else {
            setInvoiceData(defaultValues);
        }
    };

    useEffect(() => {
        loadInvoiceData();
    }, [props.invoice, props.totalBonus, props.nextInvoiceNumber]);

    useEffect(() => {
        reset(invoiceData);
    }, [invoiceData]);

    const onSubmit = async (invoice: Invoice) => {
        invoice = props.formatData(invoice);

        if (invoice.id === 0) {
            let result = await post(`v1.0/clients/${props.clientNumber}/projects/${props.projectNumber}/invoice`, invoice);

            if (response.ok) {
                let newInvoice = invoiceData;
                newInvoice.id = result;
                setInvoiceForm(newInvoice);
                setSubmittingFees(true);
                setTimeout(() => { onCloseDialog(); }, 500);
            } else if (result?.messageCode === '15') {
                window.alert('CALMS Update failed');
            } else  {
                window.alert('Create Invoice failed');
            }
        } else {
            let result = await put(`v1.0/clients/${props.clientNumber}/projects/${props.projectNumber}/invoice`, invoice);
            if (response.ok) {
                setSubmittingFees(true);
                setTimeout(() => { onCloseDialog(); }, 500);
            } else if (result?.messageCode === '15') {
                window.alert('CALMS Update failed');
            } else  {
                window.alert('Update Invoice failed');
            }
        }
    };

    const updateTotals = () => {
        let rep = getValues();
        setValue('invoiceTotal', parseFloat(rep.bonusAmount) + parseFloat(rep.recordingFee) + parseFloat(rep.rentAmount) + parseFloat(rep.bankCharge) + parseFloat(rep.otherFee));
    };

    const updateCurrentStep = (index: number) => {
        setCurrentStep(index);
    };

    const onCloseDialog = () => {
        setCurrentStep(0);
        setSubmittingFees(false);
        props.hideDialog(true);
    };

    const nextStep = () => {
        let ref = getValues();
        console.log(ref);

        let invoice: Invoice = props.invoice ? props.invoice : new Invoice();
        invoice.invoiceNumber = ref.invoiceNumber;
        invoice.collectNumber = ref.collectNumber;
        invoice.agreementInHandDate = ref.agreementInHandDate;
        invoice.draftNumber = ref.draftNumber;
        invoice.invoiceDueDate = ref.invoiceDueDate;
        invoice.draftDueDate = ref.draftDueDate;
        invoice.checkNumber = ref.checkNumber;
        invoice.bonusAmount = ref.bonusAmount;
        invoice.recordingFee = ref.recordingFee;
        invoice.rentAmount = ref.rentAmount;
        invoice.invoiceTotal = ref.invoiceTotal;
        invoice.bankCharge = ref.bankCharge;
        invoice.arDate = ref.arDate;
        invoice.paidAmount = ref.paidAmount;
        invoice.datePaid = ref.datePaid;
        invoice.checkSent = ref.checkSent;
        invoice.collectionType = ref.collectionType;
        invoice.invoiceStatus = ref.invoiceStatus;
        invoice.checkDate = ref.checkDate;
        invoice.clientInvoiceNotes = ref.clientInvoiceNotes;
        invoice.invoiceableLookupId = ref.invoiceableLookupId;
        invoice.otherFee = ref.otherFee;

        invoice = props.formatData(invoice);

        setInvoiceForm(invoice);
        setCurrentStep(1);
    };

    return (
        <DialogWizard
            title="Add Invoice"
            dialogName={props.dialogName}
            showProgress={true}
            currentStep={currentStep}
            onChangeStep={setCurrentStep}
        >
            <DialogWizardPage title="Add Invoice">
                <div className="mb-1 mt-1" style={{ width: '85vw', maxHeight: '50vh', overflow: 'auto' }}>
                    <div className="mr-2">
                        <div style={{ display: 'flex' }}>
                            <div style={{ padding: '1rem', width: '50%' }}>
                                <div style={{ fontSize: '1.6rem' }}>Bonus Amount</div>
                                <div>{props.bonusAmount ? props.bonusAmount : 0}</div>
                            </div>
                            <div style={{ padding: '1rem', width: '50%' }}>
                                <div style={{ fontSize: '1.6rem' }}>Bonus Type</div>
                                <div>{props.bonusType && props.bonusType !== '' ? props.bonusType : 'N/A'}</div>
                            </div>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <FormRow style={{ display: 'flex', gap: '1rem' }}>
                            <RHFInputBox name="invoiceNumber" label="Invoice #" register={register} errors={errors} disabled={true} bodyStyle={{ width: '15%' }} />
                            {/* tslint:disable-next-line: max-line-length */}
                            <RHFInputBox name="collectNumber" label="Collect #" register={register} errors={errors} type="number" disabled={invoiceData?.invoiceStatus === 'Posted' || invoiceData?.invoiceStatus === 'Void'} bodyStyle={{ width: '15%' }} />
                            {/* tslint:disable-next-line: max-line-length */}
                            <RHFInputBox name="draftDueDate" label="Draft Due Date" register={register} errors={errors} type="date" disabled={invoiceData?.invoiceStatus === 'Posted' || invoiceData?.invoiceStatus === 'Void'} bodyStyle={{ width: '15%' }} />
                            {/* tslint:disable-next-line: max-line-length */}
                            <RHFInputBox name="invoiceDueDate" label="Invoice Due Date" register={register} errors={errors} type="date" disabled={invoiceData?.invoiceStatus === 'Posted' || invoiceData?.invoiceStatus === 'Void'} bodyStyle={{ width: '15%' }} />
                        </FormRow>
                        <FormRow style={{ display: 'flex', gap: '1rem' }}>
                            {/* tslint:disable-next-line: max-line-length */}
                            <RHFInputBox name="bonusAmount" label="Bonus Amount" onChange={() => updateTotals()} register={register} errors={errors} type="number" disabled={invoiceData?.invoiceStatus === 'Posted' || invoiceData?.invoiceStatus === 'Void'} bodyStyle={{ width: '15%' }} />
                            {/* tslint:disable-next-line: max-line-length */}
                            <RHFInputBox name="rentAmount" label="Rent Amount" onChange={() => updateTotals()} register={register} errors={errors} type="number" disabled={invoiceData?.invoiceStatus === 'Posted' || invoiceData?.invoiceStatus === 'Void'} bodyStyle={{ width: '15%' }} />
                            {/* tslint:disable-next-line: max-line-length */}
                            <RHFInputBox name="recordingFee" label="Recording Fee" onChange={() => updateTotals()} register={register} errors={errors} type="number" disabled={true} bodyStyle={{ width: '15%' }} />
                            {/* tslint:disable-next-line: max-line-length */}
                            <RHFInputBox name="bankCharge" label="Bank Charge" onChange={() => updateTotals()} register={register} errors={errors} type="number" disabled={invoiceData?.invoiceStatus === 'Posted' || invoiceData?.invoiceStatus === 'Void'} bodyStyle={{ width: '15%' }} />
                            {/* tslint:disable-next-line: max-line-length */}
                            <RHFInputBox name="otherFee" label="Other (Please specify)" onChange={() => updateTotals()} register={register} errors={errors} type="number" disabled={invoiceData?.invoiceStatus === 'Posted' || invoiceData?.invoiceStatus === 'Void'} bodyStyle={{ width: '15%' }} />
                        </FormRow>
                        <FormRow style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <RHFInputBox name="invoiceTotal" label="Invoice Total" register={register} errors={errors} type="number" disabled={true} />
                        </FormRow>
                        <FormRow>
                            <RHFTextArea name="clientInvoiceNotes" label="Client Invoice Notes" register={register} errors={errors} />
                        </FormRow>
                        <FormRow>
                            <div style={{ padding: '1rem' }}>
                                <Button text="Submit" intent="primary" type="submit" />
                            </div>
                            <div style={{ padding: '1rem' }}>
                                <Button text="Add Recording Fees" intent="primary" onClick={() => nextStep()} />
                            </div>
                            <div style={{ padding: '1rem' }}>
                                <Button text="Cancel" intent="primary" onClick={() => onCloseDialog()} />
                            </div>
                        </FormRow>
                    </form>
                </div>
            </DialogWizardPage>
            <DialogWizardPage title="Update Recording Fees">
                <RecordingFeeListDialog
                    clientNumber={props.clientNumber}
                    projectNumber={props.projectNumber}
                    invoiceNumber={props.invoice?.invoiceNumber}
                    invoice={invoiceForm}
                    isSubmitting={submittingFees}
                    countyId={props.countyId}
                    stateId={props.stateId}
                    setCurrentStep={(index: number) => updateCurrentStep(index)}
                    onCancel={() => onCloseDialog()}
                    submitWithFees={(invoice: Invoice) => onSubmit(invoice)}
                />
            </DialogWizardPage>
        </DialogWizard>

    );
};

export default AddInvoiceDialog;


// WEBPACK FOOTER //
// ./src/components/invoicing/components/AddInvoiceDialog.tsx